/* eslint-disable react-hooks/exhaustive-deps */
import React, { Component, Fragment, useState } from 'react';
import AMap from 'AMap';
import { Toast } from 'antd-mobile' // 加载 JS
import './App.scss';
import './map.scss';

import CoverImg from './assets/cover.png';
import JHIcon from './assets/jh-icon.png';
import GPS from './utils/gps';
import { getData, postData, getDistance, getNearestPoint } from './utils/utils';
import { getPoiList } from './api/index';

// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();

const wx = window.wx;
let routeLine;
// 原始坐标wgs84
const mapConfig = {
  xmax_ymax: [108.98792624, 34.23658490],
  xmin_ymin: [108.97994399, 34.23425674],
  defaultZoom: 17, // 默认缩放级别
  maxZoom: 20, // 最大缩放级别
  minZoom: 14, // 最小缩放级别
  defaultMapCenter: [108.98524404, 34.23527598],
};
const categoryList = [
  {
    id: 0,
    category_name: '景点',
    width: 0.4,
    height: 0.36,
  },
  {
    id: 1,
    category_name: '卫生间',
    width: 0.32,
    height: 0.4,
  },
  {
    id: 2,
    category_name: '出入口',
    width: 0.4,
    height: 0.36,
  },
  {
    id: 3,
    category_name: '客服中心',
    width: 0.39,
    height: 0.41,
  },
  {
    id: 4,
    category_name: '运动健身',
    width: 0.4,
    height: 0.32,
  },
  {
    id: 5,
    category_name: '母婴室',
    width: 0.4,
    height: 0.47,
  },
  {
    id: 6,
    category_name: '停车场',
    width: 0.37,
    height: 0.37,
  },
]
// const categoryList = [
//   {
//     id: 0,
//     category_name: '景点',
//     width: 0.4,
//     height: 0.36,
//   },
//   {
//     id: 1,
//     category_name: '商铺',
//     width: 0.4,
//     height: 0.36,
//   },
//   {
//     id: 2,
//     category_name: '轻轨站',
//     width: 0.5,
//     height: 0.28,
//   },
//   {
//     id: 3,
//     category_name: '便利店',
//     width: 0.32,
//     height: 0.38,
//   },
//   {
//     id: 4,
//     category_name: '自贩机',
//     width: 0.34,
//     height: 0.38,
//   },
//   {
//     id: 5,
//     category_name: '花车',
//     width: 0.5,
//     height: 0.28,
//   },
//   {
//     id: 6,
//     category_name: '卫生间',
//     width: 0.32,
//     height: 0.4,
//   },
//   // {
//   //   id: 7,
//   //   category_name: '闲栖阁',
//   //   width: 0.4,
//   //   height: 0.4,
//   // },
//   // {
//   //   id: 8,
//   //   category_name: '客服中心',
//   //   width: 0.39,
//   //   height: 0.41,
//   // },
//   // {
//   //   id: 9,
//   //   category_name: '运动健身',
//   //   width: 0.4,
//   //   height: 0.32,
//   // },
//   // {
//   //   id: 10,
//   //   category_name: '儿童娱乐',
//   //   width: 0.41,
//   //   height: 0.4,
//   // },
//   // {
//   //   id: 11,
//   //   category_name: '停车场',
//   //   width: 0.37,
//   //   height: 0.37,
//   // },
// ];

let map = null;

const SpotListComponent = ({ isShowSpotList, poiArr, closeSpotList, setSpotActive }) => {
  const [curPage, setCurPage] = useState('景点');
  const curPoiArr = poiArr.filter((item) => item.category_name === curPage);
  return (
    <div
      className={`spotlist-div `}
      style={{
        right: isShowSpotList ? '0' : '-100%',
      }}
    >
      <div
        className="spotClose"
        onClick={() => {
          closeSpotList();
        }}
      >
        <img src={require('./assets/jdlb-icon.png')} className="close-img" alt="" />
      </div>
      <div className="spotlist">
        {/* <div className="stitle">
          <div className="tabs">
            <div
              className={`item ${curPage === '景点' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                if (curPage === '景点') return;
                setCurPage('景点');
              }}
            >
              景点列表
            </div>
            <div
              className={`item ${curPage === '商铺' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                if (curPage === '商铺') return;
                setCurPage('商铺');
              }}
            >
              商户列表
            </div>
          </div>
        </div> */}
        <div className="scontent">
          <div className="left">
            {curPoiArr.map((item, index) => {
              return index % 2 === 0 ? (
                <div
                  className="spot-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSpotActive(item, curPage);
                  }}
                  key={index}
                >
                  {item.banner ? (
                    <img
                      src={item.banner + '?x-oss-process=image/resize,h_200'}
                      className="simg"
                      alt=""
                    />
                  ) : (
                    <div className="simg imgcenter">
                      <img src={CoverImg} alt="" />
                    </div>
                  )}
                  <div className="sname">{item.name}</div>
                </div>
              ) : null;
            })}
          </div>
          <div className="right">
            {curPoiArr.map((item, index) => {
              return index % 2 === 1 ? (
                <div
                  className="spot-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSpotActive(item, curPage);
                  }}
                  key={index}
                >
                  {item.banner ? (
                    <img
                      src={item.banner + '?x-oss-process=image/resize,h_200'}
                      className="simg"
                      alt=""
                    />
                  ) : (
                    <div className="simg imgcenter">
                      <img src={CoverImg} alt="" />
                    </div>
                  )}
                  <div className="sname">{item.name}</div>
                </div>
              ) : null;
            })}
          </div>
        </div>
        <div style={{ width: '100%', height: '0.2rem' }}></div>
      </div>
    </div>
  );
};

class LMapComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category_name: '景点',
      isShowScenicInfo: false,
      curSpotInfo: {},
      isShowSpotList: false,
    };
    this.userPos = [0, 0];
    //this.userPos = mapConfig.defaultMapCenter;
    this.poiArr = [];
    this.markerArr = [];
  }
  // 页面加载完成后，初始化地图，微信配置信息，用户位置
  async componentDidMount() {
    await this.initMap();
    await this.getScenicList();
    await this.getWxConfig();
    await this.drawUserPos(this.userPos, 30);
  }
  // 初始化地图
  initMap = () => {
    let gpsItem = GPS.gcj_encrypt(mapConfig.defaultMapCenter[1], mapConfig.defaultMapCenter[0]);
    const center = [gpsItem.lon, gpsItem.lat];
    console.log(center);
    map = new AMap.Map('qjc-map', {
      expandZoomRange: true,
      resizeEnable: true,
      center,
      zoom: mapConfig.defaultZoom,
      zooms: [mapConfig.minZoom, mapConfig.maxZoom],
      // mapStyle: 'amap://styles/a79d4593c5818e3c36f7489383da372a',
      features: ['bg', 'building', 'road'],
      showIndoorMap: false,
    });
    this.addTileLayer();
    this.addMapEvent();
  };

  // 加载瓦片地图
  addTileLayer() {
    const wapMap = new AMap.TileLayer({
      getTileUrl: function (x, y, z) {
        const url = `https://qinglongsi.oss-cn-beijing.aliyuncs.com/amap_tile/${z}/${x}/${y}.png`;
        // const url = 'https://cdn.heyolx.com/newtiles/' + z + '/' + x + '_' + y + '.png';
        return url;
      },
      zIndex: 99,
      zooms: [mapConfig.minZoom, mapConfig.maxZoom],
    });
    wapMap.setMap(map);
  }

  // 添加地图点击事件
  addMapEvent() {
    map.on('click', (e) => {
      console.log('map', e);
      this.setState({
        isShowScenicInfo: false,
        showMenuList: false,
      });
    });
    map.on('zoomchange', (e) => {
      let zoom = map.getZoom();
      console.log(zoom)
      if (zoom === mapConfig.minZoom) {
        Toast.show({
          content: '地图已缩放至最小',
        })
      }
      if (zoom === mapConfig.maxZoom) {
        Toast.show({
          content: '地图已缩放至最大',
        })
      }
    });
  }

  // 判断用户是否在景区
  isInQjc = (userPos) => {
    return (
      userPos[0] >= mapConfig.xmin_ymin[0] &&
      userPos[0] <= mapConfig.xmax_ymax[0] &&
      userPos[1] >= mapConfig.xmin_ymin[1] &&
      userPos[1] <= mapConfig.xmax_ymax[1]
    );
  };

  // 缩放，定位，指南针组件
  ScaleComponent = (isInWeiXin) => {
    const { isShowScenicInfo } = this.state;
    return (
      <Fragment>
        <div className="scale" style={{ bottom: isShowScenicInfo ? '2.5rem' : '0.4rem' }}>
          <div className="menu-div" style={{ marginBottom: '0.7rem' }}>
            <img
              className="menu-icon"
              src={require('./assets/menu-icon.png')}
              alt=""
              onClick={() => {
                this.setState({
                  isShowSpotList: true,
                  isShowScenicInfo: false,
                  showMenuList: false,
                });
              }}
            />
          </div>
          <img
            className="btn-icon"
            src={require('./assets/scale-add.png')}
            alt=""
            style={{ marginBottom: '0.3rem' }}
            onClick={() => {
              if (map.getZoom() >= mapConfig.maxZoom) {
                Toast.show({
                  content: `已经缩放到最大`,
                })
                return;
              }
              map.zoomIn();
            }}
          />
          <img
            className="btn-icon"
            src={require('./assets/scale-min.png')}
            alt=""
            onClick={() => {
              if (map.getZoom() <= mapConfig.minZoom) {
                Toast.show({
                  content: '已经缩放到最小',
                })
                return;
              }
              map.zoomOut();
            }}
          />
        </div>
        <div className="userpos" style={{ bottom: isShowScenicInfo ? '2.5rem' : '0.4rem' }}>
          <img
            className="btn-icon"
            src={require('./assets/userpos.png')}
            alt=""
            onClick={() => {
              const isIn = this.isInQjc(this.userPos);
              if (isIn) {
                map.setCenter(this.userPos);
              } else {
                Toast.show({
                  content: '当前位置不在景区',
                })
              }
            }}
          />
        </div>
        <img className="znzicon" src={require('./assets/znz.png')} alt="" />
      </Fragment>
    );
  };

  // 更改GPS坐标
  changePoiPosType = (spotList) => {
    let promise = new Promise((resolve, reject) => {
      spotList.map((item, index) => {
        let gpsItem = GPS.gcj_encrypt(item.gps[1], item.gps[0]);
        item.gps = [gpsItem.lon, gpsItem.lat];
      });
      resolve(spotList);
    });
    return promise;
  };

  // 获取景点列表
  getScenicList = async () => {
    await getPoiList()
      .then((res) => {
        console.log(res);
        const spotList = res.data.spot_list.map((item) => {
          item.category_name = '景点';
          return item;
        });
        const shop_list = res.data.shop_list
          ? res.data.shop_list.map((item) => {
            item.category_name = '商铺';
            return item;
          })
          : [];
        const infrastructure_list = res.data.infrastructure_list;
        this.changePoiPosType([...spotList, ...shop_list, ...infrastructure_list]).then((res) => {
          console.log(res)
          this.poiArr = res;
          this.drawScenicList();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // 画所选景点列表
  drawScenicList() {
    const count = this.markerArr.length;
    const renderClusterMarker = function (context) {
      console.log(context);
      var factor = Math.pow(context.count / count, 1 / 18);
      var div = document.createElement('div');
      var Hue = 180 - factor * 180;
      var bgColor = 'hsla(' + Hue + ',100%,50%,0.7)';
      var fontColor = 'hsla(' + Hue + ',100%,20%,1)';
      var borderColor = 'hsla(' + Hue + ',100%,40%,1)';
      var shadowColor = 'hsla(' + Hue + ',100%,50%,1)';
      div.style.backgroundColor = bgColor;
      var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
      div.style.width = div.style.height = size + 'px';
      div.style.border = 'solid 1px ' + borderColor;
      div.style.borderRadius = size / 2 + 'px';
      div.style.boxShadow = '0 0 1px ' + shadowColor;
      div.innerHTML = context.count;
      div.style.lineHeight = size + 'px';
      div.style.color = fontColor;
      div.style.fontSize = '14px';
      div.style.textAlign = 'center';
      context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
      context.marker.setContent(div);
    };
    const category_name = this.state.category_name;
    let arr = this.poiArr.filter((item) => item.category_name === category_name);
    map.remove(this.markerArr);
    if (this.nearestMarker) map.remove(this.nearestMarker);
    if (this.MarkerClusterer) {
      map.remove(this.MarkerClusterer);
      this.MarkerClusterer = null;
    }
    this.markerArr = [];
    if (arr.length <= 0) {
      Toast.show({
        content: `暂无${category_name}数据`,
      })
      return;
    }
    arr.map((item) => {
      this.drawSpotLabel(
        item,
        categoryList.findIndex((item) => item.category_name === category_name)
      );
    });
    // map.plugin(['AMap.MarkerClusterer'], ()=> {
    // 	console.log("lipper");
    // 	this.MarkerClusterer = new AMap.MarkerClusterer(map, this.markerArr, {
    // 		gridSize: 80,
    // 		renderClusterMarker: renderClusterMarker
    // 	});
    // });
    const stsArr = new Array(5).fill({
      url: JHIcon,
      size: new AMap.Size(this.remTopx(0.48), this.remTopx(0.56)),
      offset: new AMap.Pixel(this.remTopx(-0.24), this.remTopx(-0.28)),
      textColor: '#1BC075',
      // textSize:20,
    });

    this.MarkerClusterer = new AMap.MarkerClusterer(map, this.markerArr, {
      gridSize: 20,
      styles: stsArr,
      // renderClusterMarker: renderClusterMarker,
    });
    console.log(this.MarkerClusterer);
  }

  // 计算字长
  getTitleNameLength(name) {
    const AZLength = name.length - name.replace(/[A-Z]/g, '').length;
    let titleLength = name
      .replace('...', 'aa')
      .replace('“', 'a')
      .replace('”', 'a')
      .replace('、', 'aa')
      .replace('（', 'aa')
      .replace('）', 'aa')
      .replace(/[0-9]/g, 'aa')
      .replace(/[A-Z]/g, '')
      .replace(/[\u4E00-\u9FA5]/g, 'aa').length;
    titleLength = (titleLength / 2) * 24 + AZLength * 16;
    // let titleLength = name.length;
    // titleLength = titleLength * 24 + 10;
    return titleLength / 100;
  }

  remTopx = (rem) => {
    let fontSize = (document.documentElement.clientWidth / 750) * 100;
    if (document.documentElement.clientWidth > 750) {
      fontSize = 100;
    }
    return rem * fontSize;
  };

  drawSpotLabel(info, typeIndex) {
    const isNearest = info.isNearest;
    if (isNearest) map.setCenter(info.gps);
    const borderColor = isNearest ? '#FFFFFF' : '#1BC075';
    const backgroundColor = isNearest ? '#FFB31A' : '#FFFFFF';
    let iconUrl = require(`./assets/icon-type/icon${typeIndex}${isNearest ? '-active' : ''}.png`);
    const titleLength = this.getTitleNameLength(info.name);
    const marker = new AMap.Marker({
      position: info.gps,
      content: `<div class="marker-div">
                        <div class='top ${isNearest ? 'top-active' : ''}' >
                            <div class='icon' style='border: 0.04rem solid ${borderColor};background-color:${backgroundColor}' >
                                <img class='img' src=${iconUrl} />
                            </div>
                            <div class="text ${isNearest ? 'text-active' : ''}" style="display:${isNearest ? 'flex' : 'none'
        };width:${titleLength}rem" >${info.name}</div>
                        </div>
                        <div class='bottom ${isNearest ? 'bottom-active' : ''
        }' style='border-top:0.15rem solid ${borderColor}' ></div>
                     </div>`,
      offset: new AMap.Pixel(parseInt(this.remTopx(-0.2)), parseInt(this.remTopx(-0.6))),
      zIndex: isNearest ? 9999 : 1,
    });
    if (isNearest) {
      this.nearestMarker = marker;
    } else {
      this.markerArr.push(marker);
    }
    marker.extData = info;
    map.add(marker);
    AMap.event.addListener(marker, 'click', (e) => {
      this.clearRouterLine();
      this.poiArr = this.poiArr.map((item) => {
        item.isNearest = item.id === info.id && item.category_name === info.category_name;
        return item;
      });
      this.drawScenicList();
      this.setState({
        curSpotInfo: info,
        isShowScenicInfo: true,
        showMenuList: false,
      });
    });
  }

  formatDistanceValue = (v) => {
    if (v > 1000) {
      v = v / 1000;
      v = v % 1 === 0 ? v : v.toFixed(1);
      v = `${v}km`;
    } else {
      v = parseInt(v);
      v = `${v}m`;
    }
    return v;
  };
  clearRouterLine() {
    if (this.walking) {
      this.walking.clear();
      map.remove(routeLine);
      console.log(this.walking);
    }
  }
  walkingRoute = (info) => {
    console.log(info)
    wx.openLocation({
      latitude: info.gps[1], // 纬度，浮点数，范围为90 ~ -90
      longitude: info.gps[0], // 经度，浮点数，范围为180 ~ -180。
      name: info.name, // 位置名
      address: '', // 地址详情说明
      scale: 17, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
  }
  // walkingRoute = (gps) => {
  //   this.clearRouterLine();
  //   this.walking = new AMap.Walking({
  //     // map: map,
  //     // isOutline: false,
  //     // autoFitView: true,
  //     // hideMarkers: true,
  //   });
  //   this.walking.search(this.userPos, gps, function (status, result) {
  //     if (status === 'complete') {
  //       if (result.routes && result.routes.length) {
  //         //drawRoute(result.routes[0])

  //         function parseRouteToPath(route) {
  //           var path = [];

  //           for (var i = 0, l = route.steps.length; i < l; i++) {
  //             var step = route.steps[i];

  //             for (var j = 0, n = step.path.length; j < n; j++) {
  //               path.push(step.path[j]);
  //             }
  //           }

  //           return path;
  //         }

  //         var path = parseRouteToPath(result.routes[0]);

  //         // var startMarker = new AMap.Marker({
  //         // 	position: path[0],
  //         // 	icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
  //         // 	map: map,
  //         // });

  //         // var endMarker = new AMap.Marker({
  //         // 	position: path[path.length - 1],
  //         // 	icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
  //         // 	map: map,
  //         // });

  //         routeLine = new AMap.Polyline({
  //           path: path,
  //           isOutline: true,
  //           outlineColor: '#fff',
  //           borderWeight: 1,
  //           strokeWeight: 5,
  //           strokeColor: '#00F9FF',
  //           lineJoin: 'round',
  //           showDir: true,
  //         });

  //         routeLine.setMap(map);

  //         // 调整视野达到最佳显示区域
  //         map.setFitView([routeLine]);
  //       }
  //     } else {
  //     }
  //   });
  // };

  SpotInfoComponent = (info) => {
    let dis = getDistance(this.userPos, info.gps);
    dis = this.formatDistanceValue(dis);
    let isShowDistance = this.userPos[0] !== 0;
    return (
      <div className="spotInfo">
        <div className="top">
          {info.category_name === '景点' || info.category_name === '商铺' ? (
            info.banner ? (
              <img src={info.banner} className="img" alt="" />
            ) : (
              <div className="img imgCenter">
                <img src={CoverImg} alt="" />
              </div>
            )
          ) : null}
          <div className="info">
            <div className="name">{info.name}</div>
            <div className="desc">
              {isShowDistance ? dis : '正在获取位置信息'}
              {info.category_name === '景点' || info.category_name === '商铺' ? ` | ${info.desc}` : ''}
            </div>
          </div>
        </div>
        <div className="bottom">
          {info.category_name === '景点' || info.category_name === '商铺' ? (
            <div className="btn1 type1" onClick={() => this.toScenicPage(info.id)}>
              <img src={require('./assets/menu1.png')} alt="" className="img" />
              查看详情
            </div>
          ) : (
            ''
          )}
          <div className="btn1 type1" onClick={(gps) => this.walkingRoute(info)}>
            <img src={require('./assets/menu2.png')} alt="" className="img" />
            去这里
          </div>
          <div
            className="btn1 type2"
            onClick={() => {
              this.clearRouterLine();
              this.setState({
                isShowScenicInfo: false,
              });
            }}
          >
            返回
          </div>
        </div>
      </div>
    );
  };

  getWxConfig = async () => {
    await postData('/api/applite/gs/', { url: window.location.href.split('#')[0] })
      .then((res) => {
        const data = res.data;
        wx.config({
          appId: 'wx6e497c0af99108e5',
          timestamp: Number(data.timestamp),
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: ['getLocation', 'openLocation'],
        });
      })
      .catch((res) => { });
    await this.getUserPosWx();
  };

  // 调用微信定位api
  wxGetLocation = () => {
    wx.getLocation({
      type: 'gcj02',
      success: (res) => {
        console.log('success');
        console.log(res);
        let lng = res.longitude;
        let lat = res.latitude;
        this.userPos = [lng, lat];
        this.drawUserPos(this.userPos);
        // if (!this.isGetNearest) {
        // 	this.isGetNearest = true;
        // 	if (this.isInQjc(this.userPos)) {
        // 		this.getNearestPoint();
        // 	}
        // }
      },
    });
  };

  // 获取用户位置，以及定时定位
  getUserPosWx = () => {
    const _this = this;
    let curAng = 0;
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) {
      window.addEventListener(
        'deviceorientationabsolute',
        (event) => {
          curAng = 360 - event.alpha;
          _this.markerPos.setAngle(curAng);
          // _this.drawUserPos(this.userPos, curAng);
        },
        false
      );
    } else {
      window.addEventListener('deviceorientation', DeviceOrientationHandler, false);
      function DeviceOrientationHandler(event) {
        curAng = event.webkitCompassHeading;
        _this.markerPos.setAngle(curAng);
        // _this.drawUserPos(this.userPos, curAng);
      }
    }
    wx.ready(() => {
      this.wxGetLocation();
      setInterval(() => {
        this.wxGetLocation();
      }, 5000);
    });
  };

  drawUserPos = (markerGps, curAng = 0) => {
    if (this.markerPos) {
      map.remove(this.markerPos);
      this.markerPos = null;
    }
    // const img048rem = this.remTopx(0.48);
    const img048rem = 48;
    this.markerPos = new AMap.Marker({
      icon: new AMap.Icon({
        image: require('./assets/mypos.png'),
        size: new AMap.Size(img048rem, img048rem), //图标大小
        imageSize: new AMap.Size(img048rem, img048rem),
      }),
      offset: new AMap.Pixel(img048rem * -0.5, img048rem * -0.5),
      position: markerGps,
      angle: curAng,
      bubble: true,
      zIndex: 2000,
      shape: new AMap.MarkerShape({
        coords: [0, 0, 10],
        type: 'circle',
      }),
    });
    this.markerPos.setMap(map);
  };

  closeSpotList = () => {
    this.setState({
      isShowSpotList: false,
    });
  };

  setSpotActive = (pointInfo, category_name) => {
    this.clearRouterLine();
    this.setState(
      {
        isShowScenicInfo: true,
        curSpotInfo: pointInfo,
        isShowSpotList: false,
        showMenuList: false,
        category_name,
      },
      () => {
        this.poiArr.map(
          (item) =>
            (item.isNearest = item.id === pointInfo.id && item.category_name === pointInfo.category_name)
        );
        this.drawScenicList();
      }
    );
  };

  changeCategory = (category_name) => {
    this.clearRouterLine();
    this.setState(
      {
        category_name: category_name,
        showMenuList: false,
        isShowScenicInfo: false,
      },
      () => {
        this.getNearestPoint(category_name);
      }
    );
  };

  getNearestPoint = (category_name = this.state.category_name) => {
    this.poiArr = [
      ...this.poiArr.filter((item) => item.category_name !== category_name),
      ...getNearestPoint(
        this.userPos,
        this.poiArr.filter((item) => item.category_name === category_name)
      ),
    ];
    this.drawScenicList();
  };

  setMenuComponent = (category_name, showMenuList) => {
    const curCategory = categoryList.find((item) => item.category_name === category_name) || {};
    return (
      <>
        <div
          className="menu-view"
          onClick={() => {
            this.setState({
              showMenuList: !this.state.showMenuList,
            });
          }}
        >
          <img
            src={require(`./assets/icon-type/icon${curCategory.id}.png`)}
            alt=""
            style={{
              width: `${curCategory.width / 1.5}rem`,
              height: `${curCategory.height / 1.5}rem`,
            }}
          />
          <label className="menu-view-text">{category_name}</label>
        </div>
        {showMenuList ? (
          <div className="menu-list-view">
            {categoryList.map((item) => (
              <div
                className="menu-item"
                onClick={() => {
                  this.changeCategory(item.category_name);
                }}
              >
                <div className="img-box">
                  <img
                    src={require(`./assets/icon-type/icon${item.id}.png`)}
                    alt=""
                    style={{
                      width: `${item.width}rem`,
                      height: `${item.height}rem`,
                    }}
                  />
                </div>
                <div className="text">{item.category_name}</div>
              </div>
            ))}
          </div>
        ) : null}
      </>
    );
  };

  // 跳转到小程序界面
  toScenicPage = (spotId) => {
    if (!this.toPagetime || +new Date() - this.toPagetime > 1000) {
      this.toPagetime = +new Date();
      wx.miniProgram.navigateTo({
        url: `/pages/scenic/scenic?spotId=${spotId}&scenicId=0`,
      });
    }
  };

  // 加载
  render() {
    const { isShowScenicInfo, curSpotInfo, isShowSpotList, category_name, showMenuList } = this.state;
    return (
      <Fragment>
        <div id="qjc-map" style={{ width: '100vw', height: '100vh', overflowY: 'hidden' }}></div>
        {this.ScaleComponent()}
        {isShowScenicInfo ? this.SpotInfoComponent(curSpotInfo) : null}
        {isShowSpotList ? <div className="spot-bg" onClick={() => this.closeSpotList()}></div> : null}
        {this.poiArr.length > 0 && isShowSpotList ? (
          <SpotListComponent
            isShowSpotList={isShowSpotList}
            poiArr={this.poiArr}
            closeSpotList={this.closeSpotList}
            setSpotActive={this.setSpotActive}
          />
        ) : null}
        {this.setMenuComponent(category_name, showMenuList)}
      </Fragment>
    );
  }
}

function App() {
  return (
    <div className="App">
      <LMapComponent />
    </div>
  );
}

export default App;
